module.exports = __webpack_public_path__ + "static/media/kilsaran.1beaea89.png";